import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight, Send } from 'lucide-react';
import { Button } from './ui/Button';

interface QuestionNavigationProps {
  currentStep: number;
  totalSteps: number;
  onBack: () => void;
  onNext: () => void;
  isNextDisabled?: boolean;
  isLastStep?: boolean;
}

export function QuestionNavigation({
  currentStep,
  totalSteps: _totalSteps,
  onBack,
  onNext,
  isNextDisabled = false,
  isLastStep = false,
}: QuestionNavigationProps) {
  const isFirstStep = currentStep === 1;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-6 border-t border-slate-800"
    >
      <div className="flex items-center gap-2 text-sm text-slate-500">
        <kbd className="px-2 py-1 bg-slate-800 rounded text-xs">
          {navigator.platform.includes('Mac') ? '⌘' : 'Ctrl'}+Enter
        </kbd>
        <span>to continue</span>
      </div>

      <div className="flex gap-3">
        {!isFirstStep && (
          <Button variant="secondary" onClick={onBack}>
            <ArrowLeft className="w-4 h-4" />
            Back
          </Button>
        )}

        <Button
          onClick={onNext}
          disabled={isNextDisabled}
          className="min-w-[140px]"
        >
          {isLastStep ? (
            <>
              Review Answers
              <Send className="w-4 h-4" />
            </>
          ) : (
            <>
              Continue
              <ArrowRight className="w-4 h-4" />
            </>
          )}
        </Button>
      </div>
    </motion.div>
  );
}
